import { render } from "./ScmPage.vue?vue&type=template&id=5e53d742&scoped=true"
import script from "./ScmPage.vue?vue&type=script&lang=js"
export * from "./ScmPage.vue?vue&type=script&lang=js"

import "./ScmPage.vue?vue&type=style&index=0&id=5e53d742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e53d742"]])

export default __exports__